module.exports = __webpack_public_path__ + "static/media/create-folder.73ebbc7f.svg";